<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f009-01.jpg" width="80%"/></p>
<p class="caption"><em class="italic">The distinctive darkgreen and white CWGC signposting is highly visible</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_fm022.vue?1c9a57e6